module.exports = new __parcel__URL__("invisibility.8d18cbb6.png").toString();